import { createFileRoute } from "@tanstack/react-router"

import { StaticPermissionsPage } from "@/components/permissions/StaticPermissionsPage"
import { Spinner } from "@/components/Spinner"
import { GeolocationProvider } from "@/helpers/GeolocationProvider"

import { i18n, loadLocaleResources } from "../i18n/i18n"

// no session here
const STATIC_PAGE_LANGUAGE = "cs"

export const Route = createFileRoute("/permissions")({
  loader: async () => {
    // i18n.init ships no bundle at all, so without this the page would render raw keys
    await loadLocaleResources(STATIC_PAGE_LANGUAGE)
    await i18n.changeLanguage(STATIC_PAGE_LANGUAGE)

    document.documentElement.lang = STATIC_PAGE_LANGUAGE
  },
  pendingComponent: () => <Spinner position="center" />,
  component: StaticPermissionsRoute,
})

function StaticPermissionsRoute() {
  // watchPosition is the single source of truth for geolocation: it triggers the prompt and
  // produces the permission state this page shows
  return (
    <GeolocationProvider enabled>
      <StaticPermissionsPage />
    </GeolocationProvider>
  )
}
